// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#indicator[data-v-54ca409f]{animation:spin-54ca409f 1s linear infinite;height:130px;width:130px}#circle[data-v-54ca409f]{fill:none;stroke:#6369d1;stroke-linecap:round;stroke-width:4;animation:draw-54ca409f 3s ease-in-out infinite}@keyframes draw-54ca409f{0%{stroke-dasharray:20,282.6}50%{stroke-dasharray:200,282.6}to{stroke-dasharray:20,282.6}}@keyframes spin-54ca409f{to{transform:rotate(1turn)}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
